(function () {
    'use strict';

    angular
        .module('sod.helper')
        .directive('hasMinHeight', hasMinHeight);

    function hasMinHeight() {
        return {
            restrict: 'AC',
            link: hasMinHeightLink
        };

        function hasMinHeightLink(scope, elem) {
            MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
            try {
                var observer = new MutationObserver(observerTriggeredFunc);

                // define what element should be observed by the observer
                // and what types of mutations trigger the callback
                observer.observe(elem[0], {
                    subtree: true,
                    characterData: true,
                    childList: true
                    /**
                     * childList
                     ** Set to true if mutations to target's children are to be observed.
                     *
                     * attributes
                     ** Set to true if mutations to target's attributes are to be observed.
                     *
                     * characterData
                     ** Set to true if mutations to target's data are to be observed.
                     *
                     * subtree
                     *
                     ** Set to true if mutations to not just target, but also target's descendants are to be observed.
                     *
                     * attributeOldValue
                     ** Set to true if attributes is set to true and target's attribute value before the mutation needs to be recorded.
                     *
                     * characterDataOldValue
                     ** Set to true if characterData is set to true and target's data before the mutation needs to be recorded.
                     *
                     * attributeFilter
                     ** Set to a list of attribute local names (without namespace) if not all attribute mutations need to be observed.
                     */
                });
            }
            catch (e) {
                console.warn('Mutation Error', e); // eslint-disable-line no-console
            }

            function observerTriggeredFunc() { //(mutations, observer)
                // fired when a mutation occurs
                elem.css('min-height', elem.children().height() + 50);
            }
        }
    }
})();